/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBusinessCenterIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-business-center"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.97 15.35L10.97 13.3L13.03 13.3L13.03 15.35ZM9.95 5.55L14.05 5.55L14.05 3.55Q14.05 3.55 14.05 3.55Q14.05 3.55 14.05 3.55L9.95 3.55Q9.95 3.55 9.95 3.55Q9.95 3.55 9.95 3.55ZM3.85 21.8Q2.75 21.8 1.98 21.02Q1.2 20.25 1.2 19.15L1.2 15.65L8.32 15.65L8.32 16.68Q8.32 17.23 8.71 17.61Q9.1 18 9.65 18L14.35 18Q14.9 18 15.29 17.61Q15.68 17.23 15.68 16.68L15.68 15.65L22.8 15.65L22.8 19.15Q22.8 20.25 22.02 21.02Q21.25 21.8 20.15 21.8ZM1.2 13L1.2 8.2Q1.2 7.1 1.98 6.33Q2.75 5.55 3.85 5.55L7.3 5.55L7.3 3.55Q7.3 2.45 8.07 1.68Q8.85 0.9 9.95 0.9L14.05 0.9Q15.15 0.9 15.93 1.68Q16.7 2.45 16.7 3.55L16.7 5.55L20.15 5.55Q21.25 5.55 22.02 6.33Q22.8 7.1 22.8 8.2L22.8 13L15.68 13L15.68 11.97Q15.68 11.43 15.29 11.04Q14.9 10.65 14.35 10.65L9.65 10.65Q9.1 10.65 8.71 11.04Q8.32 11.43 8.32 11.97L8.32 13Z" fill={color} />
    </svg>
  );
}
